export const properties = [
    {
        images: ['/images/clapton1.jpg', '/images/clapton2.jpg', '/images/clapton3.jpg', '/images/clapton4.jpg', '/images/clapton5.jpg', '/images/clapton6.jpg', '/images/clapton7.jpg', '/images/clapton8.jpg', '/images/clapton9.jpg',],
        address: 'Clapton court',
        location: 'Ikoyi, Lagos',
        price: '# ---',
        beds: 4,
        baths: '0',
        levels: '0',
        sqft: '0',
        type: 'BUY'
    },
    {
        images: ['/images/maryland1.jpg', '/images/maryland2.jpg', '/images/maryland3.jpg', '/images/maryland4.jpg', '/images/maryland5.jpg', '/images/maryland6.jpg',],
        address: 'No. 2 Block 4A, Aderibigbe Shitte Street',
        location: 'Maryland, Lagos',
        price: '# ---',
        beds: 2,
        baths: '0',
        levels: '0',
        sqft: '0',
        type: 'BUY'
    },
    {
        images: ['/images/house.webp', '/images/chair.webp'],
        address: 'Emerald court, House 7, Dideolu Estate',
        location: 'Victoria Island, Lagos',
        price: '# ---',
        beds: 3,
        baths: '0',
        levels: '0',
        sqft: '0',
        type: 'BUY'
    },
    {
        images: ['/images/house.webp', '/images/chair.webp'],
        address: '36, Lake view Estate',
        location: 'Abuja',
        price: '# ---',
        beds: 4,
        baths: '0',
        levels: '0',
        sqft: '0',
        type: 'BUY'
    },
    {
        images: ['/images/house.webp', '/images/chair.webp'],
        address: '22 Akiogun Road, Oniru',
        location: 'Lekki, Lagos',
        price: '# ---',
        beds: '0',
        baths: '0',
        levels: '0',
        sqft: 300,
        type: 'BUY'
    },
    {
        images: ['/images/house.webp', '/images/chair.webp'],
        address: 'Shop A5, Shakir Plaza',
        location: 'Abuja',
        price: '# ---',
        beds: '0',
        baths: '0',
        levels: '0',
        sqft: 60,
        type: 'BUY'
    },

];

export const services = [
    {
        image: 'residence',
        heading: 'Residential Property Management',
        text: 'We specialize in the efficient management of residential properties, ensuring that tenants enjoy a comfortable and secure living environment while property owners benefit from well-maintained assets and consistent returns.',
    },
    {
        image: 'realestate',
        heading: 'Commercial Real Estate Management',
        text: 'TrueBond Properties offers full-service management for commercial properties, including office buildings, retail outlets, and mixed-use developments. Our focus is on optimizing space utilization, tenant satisfaction, and maintaining the highest standards of commercial real estate management.',
    },
    {
        image: 'maintenance',
        heading: 'Property Maintenance & Tenant Relations',
        text: 'Our services extend beyond simple management. We provide proactive maintenance, repair, and tenant relations management, ensuring properties are in top condition and tenants are happy. From handling tenant complaints to regular property inspections, we manage every aspect with attention to detail and care.',
    },
]